import React from 'react';
import { useAdmin } from '../hooks/useAdmin';

const AdminBadge = ({ style = {}, className = '' }) => {
  const { isAdmin, loading } = useAdmin();

  // Don't show badge if not admin or still loading
  if (!isAdmin || loading) return null;

  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 12px',
    backgroundColor: 'var(--color-admin)',
    color: 'white',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    boxShadow: '0 2px 4px var(--color-admin-shadow)',
    ...style,
  };

  return (
    <div className={`admin-badge ${className}`} style={badgeStyle}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
      Admin
    </div>
  );
};

export default AdminBadge;
